export const Progress = {
  baseStyle: {
    filledTrack: {
      bg: '#605AFB',
    },
  },
};
